const IFRAME_CONTAINER_ID = `solid-payment-form-container_#${Math.ceil(Math.random() * 10000)}`;
const GOOGLE_PAY_BUTTON_CONTAINER_ID = `google-pay-button-container_#${Math.ceil(Math.random() * 10000)}`;
const APPLE_PAY_BUTTON_CONTAINER_ID = `apple-pay-button-container_#${Math.ceil(Math.random() * 10000)}`;
export { IFRAME_CONTAINER_ID, GOOGLE_PAY_BUTTON_CONTAINER_ID, APPLE_PAY_BUTTON_CONTAINER_ID };
//# sourceMappingURL=index.js.map